export const GatewayIssueCategories = [
    {
        value: 0,
        description: 'Not Defined',
    },
    {
        value: 1,
        description: 'Clarify Expenditures',
    },
    {
        value: 2,
        description: 'Upload Form',
    },
    {
        value: 3,
        description: 'Missing Reports Required',
    },
    {
        value: 4,
        description: 'Line Item Amendment',
    },
    {
        value: 5,
        description: 'Excess Contribution',
    },
    {
        value: 6,
        description: 'Subvendor Related',
    },
    {
        value: 7,
        description: 'Acknowledgement',
    },
    {
        value: 8,
        description: 'Amendment Required',
    },
]

export default GatewayIssueCategories